import { useAuth } from '@/entities/Auth'
import router from '@/app/routes'
import type { AxiosError } from 'axios'
import type { CustomAxiosResponse } from './types'

/**
 * Функция обработки ошибки авторизации
 * @param error
 */
export const unAuthorizedError = (error: AxiosError) => {
  if (error.status && error.status === 401) {
    const auth = useAuth()

    auth.deleteAuth()
    auth.deleteToken()
    auth.setCurrentPage(window.location.pathname)

    router.push('/auth/login')
  }

  return Promise.reject(error)
}

/**
 * Функция очистки response от дублирования data свойства
 * @param response
 */
export const clearResponseData = (response: CustomAxiosResponse) => {
  const body = response.data
  if (body == null || typeof body !== 'object') {
    return response
  }

  if (response.data.payload) {
    response.payload = response.data.payload
  }

  if (response.data.payloads) {
    response.payload = response.data.payloads
  }

  if (response.data.data || response.data.data === null) {
    response.data = response.data.data
  }

  return response
}
